import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import moment from 'moment';
import * as actions from './DashboardLinkAccess.ducks';

// landscape components
import Col from 'zignal-landscape/lib/Col';
import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';
import Grid from 'zignal-landscape/lib/Grid';
import GridContent from 'zignal-landscape/lib/GridContent';
import Heading from 'zignal-landscape/lib/Heading';
import Row from 'zignal-landscape/lib/Row';
import {
  TABLE,
  THEAD,
  TBODY,
  TH,
  TR
} from 'zignal-landscape/lib/Table';

// presentational components
import TableLoader from 'components/TableLoader';
import SharedLinkRow from './components/SharedLinkRow';

export const mapStateToProps = (
  (state) => ({
    // DATA
    sharedTokensList: state.DashboardLinkAccess.sharedTokensList,
    userId: state.AppUser.userId,
    isCampaignAdmin: state.AppUser.isCampaignAdmin,
    timezone: state.AppUser.user.timezone,
    confirmSharedToken: state.DashboardLinkAccess.confirmSharedToken,
    successText: state.DashboardLinkAccess.successText,
    // Errors
    fetchSharedTokensError: state.DashboardLinkAccess.fetchSharedTokensError,
    deleteSharedTokenError: state.DashboardLinkAccess.deleteSharedTokenError,
    updateSharedTokenError: state.DashboardLinkAccess.updateSharedTokenError,
    // Flags
    fetchingSharedTokens: state.DashboardLinkAccess.fetchingSharedTokens,
    updatingSharedToken: state.DashboardLinkAccess.updatingSharedToken,
    deletingSharedToken: state.DashboardLinkAccess.deletingSharedToken,
    clickedIcon: state.DashboardLinkAccess.clickedIcon
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class DashboardLinkAccess extends Component {

  componentDidMount(){
    const { fetchSharedTokens, campaignId } = this.props;
    fetchSharedTokens(campaignId);
  }

  render() {
    const {
      deleteSharedToken, confirmDeleteSharedToken, fetchingSharedTokens, timezone,
      cancelDeleteSharedToken, deletingSharedToken, mouseLeaveIcon, successText,
      clickIcon, clickedIcon, updateSharedToken, updatingSharedToken, updateSharedTokenError,
      confirmSharedToken, userId, isCampaignAdmin, sharedTokensList
    } = this.props;
    const emptyTableProps ={
      header: 'No Dashboard Link to Display',
      body: <span>Dashboard links have not been<br />created for this workspace</span>
    };
    const headers = [
      { key: 'name', label: 'Dashboard Name' }, { key: 'path', label: 'Shared Link Url' },
      { key: 'createdBy', label: 'Created By' }, { key: 'createdAt', label: 'Date Created' },
      { key: 'expiresAt', label: 'Access Expires On' }
    ];

    return (
      <TableLoader
        loading={fetchingSharedTokens}
        items={sharedTokensList}
        emptyTableProps={emptyTableProps}
      >
        <GridContent>
          <Grid fluid>
            <Row>
              <Col xs={12}>
                <Heading>Dashboard Link Access</Heading>
                <i>Manage all of your privately shared dashboard links here.</i>
                <br />
                <br />
              </Col>
            </Row>
            <Row>
              <TABLE>
                <THEAD>
                  <TR>
                    {headers.map( ({ label }) => <TH key={label}>{label}</TH> )}
                    <TH key={'actions'}>Actions</TH>
                  </TR>
                </THEAD>
                <TBODY>
                  {
                    sharedTokensList.map( (token) => {
                      return (
                        <SharedLinkRow
                          key={token._id}
                          timezone={timezone}
                          token={token}
                          userId={userId}
                          isCampaignAdmin={isCampaignAdmin}
                          updateSharedToken={updateSharedToken}
                          confirmDeleteSharedToken={confirmDeleteSharedToken}
                          clickedIcon={clickedIcon}
                          clickIcon={clickIcon}
                          successText={successText}
                          updatingSharedToken={updatingSharedToken}
                          updateSharedTokenError={updateSharedTokenError}
                          mouseLeaveIcon={mouseLeaveIcon}
                        />
                      );
                    })
                  }
                </TBODY>
              </TABLE>
              <ConfirmationModal
                isOpen={!!confirmSharedToken}
                confirmStyle="delete"
                title="Delete Dashboard Link Access"
                onCancel={deletingSharedToken ? noop : cancelDeleteSharedToken}
                onConfirm={deletingSharedToken ? noop : () => deleteSharedToken(confirmSharedToken)}
              >
                {'Deleting the '}<b>Dashboard Access Link</b>{` will make the view-only dashboard
                  unavailable to all link recipients. Are you sure you want to delete this link?`}
              </ConfirmationModal>
            </Row>
          </Grid>
        </GridContent>
      </TableLoader>
    );
  }

}

DashboardLinkAccess.propTypes = {
  userId: PropTypes.string,
  isCampaignAdmin: PropTypes.bool,
  campaignId: PropTypes.string,
  timezone: PropTypes.string,
  confirmSharedToken: PropTypes.object,
  sharedTokensList: PropTypes.array,
  fetchSharedTokens: PropTypes.func,
  fetchSharedTokensError: PropTypes.object,
  updateSharedTokenError: PropTypes.object,
  updateSharedToken: PropTypes.func,
  deleteSharedTokenError: PropTypes.object,
  deleteSharedToken: PropTypes.func,
  confirmDeleteSharedToken: PropTypes.func,
  cancelDeleteSharedToken: PropTypes.func,
  fetchingSharedTokens: PropTypes.bool,
  updatingSharedToken: PropTypes.bool,
  deletingSharedToken: PropTypes.bool,
  clickedIcon: PropTypes.bool,
  clickIcon: PropTypes.func,
  successText: PropTypes.string,
  mouseLeaveIcon: PropTypes.func
};

DashboardLinkAccess.defaultProps = {
  userId: null,
  isCampaignAdmin: false,
  confirmSharedToken: null,
  sharedTokensList: [],
  fetchSharedTokensError: null,
  updateSharedTokenError: null,
  deleteSharedTokenError: null,
  fetchingSharedTokens: true,
  updatingSharedToken: false,
  deletingSharedToken: false,
  clickedIcon: false,
  successText: null,
  timezone: moment.tz.guess()
};

export default connect(mapStateToProps, actions, mergeProps)(DashboardLinkAccess);
